export type FormValidationResult = string[];

// rome-ignore lint/suspicious/noExplicitAny:
export type AbstractFormState = Record<string, any>;

/**
 * @see: https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#inferring-within-conditional-types
 */
type Flatten<Type> = Type extends Array<infer Item> ? Item : Type;

export type FormValidation<T extends AbstractFormState> = {
  [Key in keyof T]: T[Key] extends AbstractFormState[] ? FormValidation<Flatten<T[Key]>>[] : FormValidationResult;
};

function isSubTreeValid<T extends AbstractFormState>(validation: FormValidation<T>): boolean {
  for (const key in validation) {
    // rome-ignore lint/suspicious/noExplicitAny: <explanation>
    const value = validation[key] as FormValidation<T[any]> | FormValidationResult;
    if (Array.isArray(value) && value.every((item) => typeof item === "string")) {
      if (value.length > 0) {
        return false;
      }
    } else {
      // rome-ignore lint/suspicious/noExplicitAny: <explanation>
      const subTree = isSubTreeValid(value as FormValidation<T[any]>);
      if (!subTree) {
        return false;
      }
    }
  }

  return true;
}

export function isFormValid<T extends AbstractFormState>(validation: FormValidation<T>): boolean {
  return isSubTreeValid(validation);
}

export type FormValidationFunction<D extends AbstractFormState, E, F extends AbstractFormState> = (
  data: D,
  extra: E,
) => FormValidation<F>;
